<script setup>
import {computed} from "vue";

const props = defineProps({
  trend: {
    type: Number,
    required: true,
  },
});

const color = computed(() => props.trend < 0 ? 'red' : 'everest');
const direction = computed(() => props.trend < 0 ? 'down' : 'up');
</script>

<template>
  <div class="tw-w-auto tw-inline-block tw-relative">
    <span
      :class="[
        'tw-rounded tw-py-1 tw-px-2 tw-text-xs tw-flex tw-items-center tw-gap-1 tw-w-auto tw-ml-2 tw-font-medium',
        `tw-bg-${color}-lightest tw-text-${color}`,
      ]"
    >
      <svg-vue
        v-if="trend !== 0"
        :icon="`icons/trend-${direction}`"
        class="tw-h-4 tw-w-4"
      />
    </span>
  </div>
</template>